import styled, { css } from 'styled-components'

const CustomHeader = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
            padding: 20px 20px 30px 20px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            text-align: start;
            color: ${theme.colors.blue_1}
            max-width: 100vw;
            position: fixed;
            top: 0%;
            z-index: 10;
            background-color: white;
            width: 100%;
            @media ${device.tabletM} {
                padding: 30px 60px 30px 100px;
                position: fixed;
                top: 0%;
                z-index: 10;
                background-color: white;
                width: 100%;
            }
        `;
    }}
`;

const CustomLogo = styled.div`
${({ theme }) => {
        const { colors, device, fonts } = theme;
        return css`
        font-weight: ${fonts.weight.bold};
        font-size: ${fonts.size.lg};
        line-height: 20px;
        color: ${colors.black_2};
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: start;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        width: calc(100vw - 40px);

        & div {
            display: flex;
            align-items: center;
        }
        @media ${device.tablet} {
            font-size: 22px;
            line-height: 27px;
            height: 27px;
            width: calc(100vw - 267px);
        }
    `;
    }}
`;

const CustomHeader02 = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
        position: absolute;
    top: 0;
    left: 0;
    height: 68px;
        width: 100vw;
        background-image: url("https://images.unsplash.com/photo-1532292060982-8bfb986808e7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=200&q=200");
        background-position: center;
    background-size: cover;
        @media ${device.tabletM} {
            background-image: url("https://images.unsplash.com/photo-1532292060982-8bfb986808e7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1439&q=200");
        
        }
    `;
    }}
`;
const AboutPageLogo = styled(CustomLogo)`
${({ theme }) => {
        const { device } = theme;
        return css`
        position: absolute;
        top: 20px;
        left: 20px;
        color: #FFFFFF;
        @media ${device.tablet} {
            font-size: 22px;
            line-height: 27px;
            height: 27px;
            width: calc(100vw - 267px);
        }
    `;
    }}
`;

const LogoWrapper = styled.div`
${({ theme }) => {
        return css`
        display: flex;
        align-items: center;
    `;
    }}
`;


const LogoImg = styled.img`
${({ theme }) => {
        return css`
        width: 25px;
        height: 19px;
        margin-right: 8px;
    `;
    }}
`;

const LogoTitle = styled.div`
${({ theme }) => {
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 20px;
        text-align: right;
        color: #223F49;
    `;
    }}
`;

const AboutPageTitle = styled(LogoTitle)`
${({ theme }) => {
        return css`
        color: #fff;
    `;
    }}
`;

const AboutWrapper = styled.div`
${({ theme }) => {
        return css`
        font-family: Noto Sans KR;
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
        text-align: right;
        color: #223F49;

        padding: 12px;
        border-radius: 5px;
        background: #00b9e1;
        color: white;
    `;
    }}
`;

const LocationTitle = styled.div`
${({ theme }) => {
        const { colors, device, fonts } = theme;
        return css`
        font-weight: ${fonts.weight.bold};
        font-size: 25px;
        line-height: 20px;
        color: ${colors.blue_3};
        @media ${device.tablet} {
            font-size: 35px;
            line-height: 42px;
        }
        & span {
            color: ${colors.blue_1};
            margin-left: 10px;
        }
    `;
    }}
`;

const LocationTitleCoreArea = styled(LocationTitle)`
${({ theme }) => {
        const { colors, device } = theme;
        return css`
        font-size: 25px;
        line-height: 34px;
        color: ${colors.blue_3};
        & span {
            color: ${colors.blue_1};
            margin-left: 10px;
        }
        word-break: keep-all;
        @media ${device.tablet} {
            font-size: 35px;
            line-height: 42px;
            & span {
                color: ${colors.blue_1};
                margin-left: 10px;
            }
        }
    `;
    }}
`;


const styledComponents = { CustomLogo, AboutPageLogo, LogoWrapper, CustomHeader, CustomHeader02, LogoImg, LogoTitle, AboutPageTitle, LocationTitle, LocationTitleCoreArea, AboutWrapper };

export default styledComponents;